import { Link } from "react-router-dom";
import "./Header.css";
export const Header = ()=>{

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };


    return(
        
        <div class="container">
        

        <div class="top">
            <h1 class="header_logo">ArtKey</h1>

            <div class="top_right">
                    <Link to="/Main" onClick={scrollToTop}><button>SHOP</button></Link>
            </div>
            
            <div class="top_left">
                <Link to="/Reservation" onClick={scrollToTop}><button>Reservation</button></Link>
            </div>

        </div>
        </div>
        

    )
}